"use strict";

document.addEventListener("DOMContentLoaded", () => {
    try {
        initNutritionTable();
        initCategorySliders();
        initProductShowcaseNav();
        initProductShowcaseSlider();
        initProductionSlider();
        initProductSlider();
        initHeroSlider();
        initHeroMobileSlider();
        initAboutHubTopicSlider();
        initUspMobileSlider();
        initTimelineSlider();
        initHomepageHeroDownwardParallax();
        initParallaxTexts();
        initIngredientSidebars();
        initJobCollapsers();
        initCareerModal();
        initMegamenuImages();
        initStickyJob();
        initStickyRecipe();
        initStickyProduct();
        initFixedNavbarShadow();
        initJobFilters();
        initSmoothScrollBecauseAppleSucks();
        document.addEventListener("keydown", detectTabNavigation);
    } catch (e) {
        console.error(e);
    }
});

const initJobFilters = () => {
    const btns = document.querySelectorAll(".JobCategory__Button");
    const joblists = document.querySelectorAll(".JobList");
    if (btns.length > 0 && joblists.length > 0) {
        btns.forEach(btn => {
            btn.addEventListener("click", e => {
                btns.forEach(btn => {
                    if (btn === e.target) {
                        btn.classList.add("-active");
                    } else {
                        btn.classList.remove("-active");
                    }
                });
                joblists.forEach(list => {
                    if (list.id === e.target.dataset.targetId) {
                        list.classList.add("-active");
                    } else {
                        list.classList.remove("-active");
                        const jobs = list.querySelectorAll(".Job");
                        if (jobs.length > 0) {
                            jobs.forEach(job => {
                                job.classList.remove("-is-expanded");
                                job.querySelector(".Job__Collapser").style.height = 0;
                            });
                        }
                    }
                })
            })
        });
    }
}


const initNutritionTable = () => {
    const table = document.querySelector("#nutrition-table");
    if (table) {
        const bars = table.querySelectorAll(".NutritionTable__Bar");
        if (bars.length > 0) {
            const animateBars = () => {
                bars.forEach(bar => {
                    bar.style.width = `${bar.dataset.percent}%`;
                });
            };

            const st = new ScrollTrigger({
                trigger: table,
                start: "top 75%",
                onEnter: animateBars,
                onLeave: animateBars
            });
        }
    }
}

const initFixedNavbarShadow = () => {
    let timeout;
    const navbar = document.querySelector("#main-nav");
    let recalculate = true;

    const toggleShadow = () => {
        if (window.scrollY > 0) {
            navbar.style.boxShadow = "0 0 16px rgba(0,0,0,0.1)";
        } else {
            navbar.style.boxShadow = "none";
        }
    }

    if (navbar) {
        toggleShadow();

        window.addEventListener("scroll", () => {
            if (recalculate) {
                recalculate = false;
                toggleShadow();
                timeout = setTimeout(() => {
                    toggleShadow();
                    recalculate = true;
                }, 16);
            }
        })
    }
}

const initProductShowcaseNav = () => {
    let slider;
    const rootEl = document.querySelector("#product-showcase-nav-slider");
    const showcaseSliderEl = document.querySelector("#product-showcase-slider");
    let isEditor = document.body.classList.contains('isEditorMode');

    if (rootEl) {
        slider = new Swiper(rootEl, {
            allowTouchMove: false,
            slideToClickedSlide: true,
            loop: !isEditor,
            centeredSlides: true,
            breakpointsInverse: true,
            breakpoints: {
                1: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 5
                },
                992: {
                    slidesPerView: 6
                }
            }
        });
    } else {
        return
    }

    const links = rootEl.querySelectorAll(".ProductShowcase__CategoryButton");
    if (links.length > 0) {
        links.forEach(link => {
            link.addEventListener("click", () => {
                showcaseSliderEl.swiper.slideToLoop(parseInt(link.dataset.slide))
            });
        })
    }
}

const initProductShowcaseSlider = () => {
    let slider;
    const rootEl = document.querySelector("#product-showcase-slider");

    let isEditor = document.body.classList.contains('isEditorMode');

    if (rootEl) {
        const navSlider = document.querySelector("#product-showcase-nav-slider").swiper;
        slider = new Swiper(rootEl, {
            simulateTouch: false,
            loop: !isEditor,
            runCallbacksOnInit: false,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: function () {
                    initImagemapPins();
                    if (window.innerWidth < 992) {
                        const activeSlide = this.$el[0].querySelector(".swiper-slide-active");
                        activeSlide.querySelector(".ImagemapPin").click();
                    }
                },
                transitionEnd: function () {
                    if (window.innerWidth < 992) {
                        const activeSlide = this.$el[0].querySelector(".swiper-slide-active");
                        activeSlide.querySelector(".ImagemapPin").click();
                    }
                },
                slideNextTransitionStart: function () {
                    navSlider.slideNext();
                },
                slidePrevTransitionStart: function () {
                    navSlider.slidePrev();
                },
            }
        });
    }
}

const initProductionSlider = () => {
    const slider = new Swiper('#production-slider', {
        simulateTouch: false,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {
                initImagemapPins();
                if (window.innerWidth < 992) {
                    const activeSlide = this.$el[0].querySelector(".swiper-slide-active");
                    activeSlide.querySelector(".ImagemapPin").click();
                }
            },
            transitionEnd: function () {
                if (window.innerWidth < 992) {
                    const activeSlide = this.$el[0].querySelector(".swiper-slide-active");
                    activeSlide.querySelector(".ImagemapPin").click();
                }
            }
        }
    });
}

const initHeroSlider = () => {
    let slider;
    const rootEl = document.querySelector("#hero-slider");
    if (rootEl) {
        const slides = rootEl.querySelectorAll(".swiper-slide");
        slider = new Swiper(rootEl, {
            // simulateTouch: false,
            // loop: slides.length > 2 ? true : false,
            centeredSlides: true,
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (i, className) {
                    return (`
                      <button class="${className}">
                        <div class="swiper-dot-1">
                          <div class="swiper-dot-2">
                            <div class="swiper-dot-3">
                            </div>
                          </div>
                        </div>
                      </button>`
                    )
                }
            },

            breakpointsInverse: true,
            breakpoints: {
                1: {
                    slidesPerView: 1,
                },
            }
        })

        if (slider.el) {
            const bullets = slider.el.querySelectorAll(".swiper-pagination-bullet");

            if (bullets) {
                bullets.forEach(bullet => {
                    bullet.addEventListener("mouseover", () => {
                        bullet.click();
                    })
                });
            }
        }
    }

}



const initHeroMobileSlider = () => {
    let slider;
    const rootEl = document.querySelector("#heroMobile-slider");
    if (rootEl) {
        const slides = rootEl.querySelectorAll(".swiper-slide");
        slider = new Swiper(rootEl, {
            // simulateTouch: false,
            // loop: slides.length > 2 ? true : false,
            centeredSlides: true,
            slidesPerView: 1, autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".swiper-pagination-mobile",
                clickable: true,
                renderBullet: function (i, className) {
                    return (`
                      <button class="${className}">
                        <div class="swiper-dot-1">
                          <div class="swiper-dot-2">
                            <div class="swiper-dot-3">
                            </div>
                          </div>
                        </div>
                      </button>`
                    )
                }
            },

            breakpointsInverse: true,
            breakpoints: {
                1: {
                    slidesPerView: 1,
                },
            }
        })

        if (slider.el) {
            const bullets = slider.el.querySelectorAll(".swiper-pagination-bullet");

            if (bullets) {
                bullets.forEach(bullet => {
                    bullet.addEventListener("mouseover", () => {
                        bullet.click();
                    })
                });
            }
        }
    }

}


const initProductSlider = () => {
    let slider;
    const rootEl = document.querySelector("#product-slider");
    if (rootEl) {
        const slides = rootEl.querySelectorAll(".swiper-slide");
        slider = new Swiper(rootEl, {
            simulateTouch: false,
            loop: slides.length > 2 ? true : false,
            centeredSlides: true,
            slidesPerView: 3,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpointsInverse: true,
            breakpoints: {
                1: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 3,
                }
            }
        })
    }
}

const initAboutHubTopicSlider = () => {
    let slider;
    const rootEl = document.querySelector("#AboutHubTopicSlider");
    if (rootEl) {
        const slides = rootEl.querySelectorAll(".swiper-slide");
        slider = new Swiper(rootEl, {
            simulateTouch: true,
            // loop: slides.length > 2 ? true : false,
            centeredSlides: false,
            slidesPerView: 3,
            breakpointsInverse: true,
            pagination: {
                el: ".swiper-pagination-about",
                clickable: true,
                renderBullet: function (i, className) {
                    return (`
                      <button class="${className}">
                        <div class="swiper-dot-1">
                          <div class="swiper-dot-2">
                            <div class="swiper-dot-3">
                            </div>
                          </div>
                        </div>
                      </button>`
                    )
                }
            },
            breakpoints: {
                1: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        })

        if (slider.el) {
            const bullets = slider.el.querySelectorAll(".swiper-pagination-bullet");

            if (bullets) {
                bullets.forEach(bullet => {
                    bullet.addEventListener("mouseover", () => {
                        bullet.click();
                    })
                });
            }
        }

    }
}

const initUspMobileSlider = () => {
    let slider;
    const rootEl = document.querySelector("#initUspMobileSlider");
    if (rootEl) {
        const slides = rootEl.querySelectorAll(".swiper-slide");
        slider = new Swiper(rootEl, {
            simulateTouch: true,
            // loop: slides.length > 2 ? true : false,
            centeredSlides: false,
            slidesPerView: 1,
            breakpointsInverse: true,
            pagination: {
                el: ".swiper-pagination-about",
                clickable: true,
                renderBullet: function (i, className) {
                    return (`
                      <button class="${className}">
                        <div class="swiper-dot-1">
                          <div class="swiper-dot-2">
                            <div class="swiper-dot-3">
                            </div>
                          </div>
                        </div>
                      </button>`
                    )
                }
            },
            breakpoints: {
                1: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        })

        if (slider.el) {
            const bullets = slider.el.querySelectorAll(".swiper-pagination-bullet");

            if (bullets) {
                bullets.forEach(bullet => {
                    bullet.addEventListener("mouseover", () => {
                        bullet.click();
                    })
                });
            }
        }

    }
}


const initCategorySliders = () => {
    const navSlider = initCategoryNavSlider();
    const detailSlider = initCategoryDetailSlider();
    if (navSlider && detailSlider) {
        navSlider.controller.control = detailSlider;
        detailSlider.controller.control = navSlider;
    }
}

const initCategoryNavSlider = () => {
    let slider;
    const rootEl = document.querySelector('#category-nav-slider');
    if (rootEl) {
        const slides = rootEl.querySelectorAll(".swiper-slide");
        slider = new Swiper(rootEl, {
            simulateTouch: false,
            loop: slides.length > 2 ? true : false,
            centeredSlides: true,
            slidesPerView: 3,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpointsInverse: true,
            breakpoints: {
                1: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 3,
                }
            }
        });
        return slider;
    }
}

const initCategoryDetailSlider = () => {
    let slider;
    const rootEl = document.querySelector('#category-detail-slider');
    if (rootEl) {
        const slides = rootEl.querySelectorAll(".swiper-slide");
        slider = new Swiper(rootEl, {
            allowTouchMove: false,
            loop: slides.length > 2 ? true : false,
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            on: {
                init: function () {
                    initImagemapPins();
                    if (window.innerWidth < 992) {
                        const activeSlide = this.$el[0].querySelector(".swiper-slide-active");
                        activeSlide.querySelector(".ImagemapPin").click();
                    }
                },
                transitionEnd: function () {
                    if (window.innerWidth < 992) {
                        const activeSlide = this.$el[0].querySelector(".swiper-slide-active");
                        activeSlide.querySelector(".ImagemapPin").click();
                    }
                }
            }
        });
    }
    ;
}


const initHomepageHeroDownwardParallax = () => {
    const plx = document.querySelector(".Hero__HomepageTitle");
    if (plx) {
        const animation = gsap.to(plx, {
            scrollTrigger: {
                trigger: document.querySelector("main"),
                start: "top top",
                endTrigger: plx,
                end: "bottom+=100px top",
                toggleActions: "play none reverse reverse",
                scrub: true,
            },
            y: plx.clientHeight * 1.5,
            opacity: 0,
            duration: 0.5
        });
    }
}

const initParallaxTexts = () => {
    const plxWrappers = document.querySelectorAll(".ParallaxText");

    if (plxWrappers.length > 0) {
        plxWrappers.forEach(wrp => {
            const scaler = wrp.querySelector(".ParallaxText__Scaler");
            const plx = wrp.querySelector(".ParallaxText__Content");

            if (scaler) {
                scaler.style.transform = `scale(${window.innerWidth / scaler.clientWidth})`;
                wrp.style.height = `${scaler.getBoundingClientRect().height}px`;
            }

            const animation = gsap.to(plx, {
                scrollTrigger: {
                    trigger: document.querySelector(wrp.dataset.startTgr) || undefined,
                    start: wrp.dataset.start,
                    endTrigger: document.querySelector(wrp.dataset.endTgr) || undefined,
                    end: wrp.dataset.end,
                    toggleActions: "play none reverse reverse",
                    scrub: true,
                },
                y: -1 * plx.clientHeight,
                opacity: 0,
                duration: 0.5
            });
        });
    }
}


const initStickyJob = () => {
    const container = document.querySelector(".JobListings");
    const sticky = document.querySelector("#gsap-sticky-career");
    const recalculateButtons = document.querySelectorAll(".Job .Button.-gblack");

    if (sticky) {
        const st = ScrollTrigger.create({
            trigger: sticky,
            endTrigger: container,
            start: `top top+=85px`,
            end: `bottom 50%`,
            pin: true,
        });

        ScrollTrigger.addEventListener("refreshInit", () => {
            if (Math.floor(window.innerWidth) < 992) {
                st.disable();
            } else {
                st.enable();
            }
        })

        ScrollTrigger.addEventListener("refreshInit", () => {
            st.spacer.style.height = "100%";
        });

        ScrollTrigger.addEventListener("refresh", () => {
            st.spacer.style.height = "100%";
        });

        recalculateButtons.forEach(btn => {
            btn.addEventListener("click", () => {
                setTimeout(() => {
                    ScrollTrigger.refresh();
                }, 300);
            });
        })
    }
}

const initStickyRecipe = () => {
    const container = document.querySelector(".ArticleBody");
    const sticky = document.querySelector("#gsap-sticky-recipe");

    if (sticky) {
        const st = ScrollTrigger.create({
            trigger: sticky,
            endTrigger: container,
            start: `top top+=85px`,
            end: `bottom bottom`,
            pin: true,
        });

        ScrollTrigger.addEventListener("refreshInit", () => {
            if (Math.floor(window.innerWidth) < 1200) {
                st.disable();
            } else {
                st.enable();
            }
        })

        ScrollTrigger.addEventListener("refreshInit", () => {
            st.spacer.style.height = "100%";
        });

        ScrollTrigger.addEventListener("refresh", () => {
            st.spacer.style.height = "100%";
        });
    }
}

const initStickyProduct = () => {
    const container = document.querySelector(".Product__BasicInfoCol");
    const sticky = document.querySelector("#gsap-sticky-product");

    if (sticky) {
        const st = ScrollTrigger.create({
            trigger: sticky,
            endTrigger: container,
            start: `top top+=85px`,
            end: `bottom bottom`,
            pin: true,
        });

        ScrollTrigger.addEventListener("refreshInit", () => {
            if (Math.floor(window.innerWidth) < 992) {
                st.disable();
            } else {
                st.enable();
            }
        })

        ScrollTrigger.addEventListener("refreshInit", () => {
            st.spacer.style.height = "100%";
        });

        ScrollTrigger.addEventListener("refresh", () => {
            st.spacer.style.height = "100%";
        });
    }
}

const initTimelineSlider = () => {
    const slider = new Swiper("#timeline-slider", {
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (i, className) {
                const title = this.slides[i].dataset.title;
                return (`
          <button class="${className}">
            <div class="swiper-dot-1">
              <div class="swiper-dot-2">
                <div class="swiper-dot-3">
                  <span class="swiper-bullet-text">
                    ${title}
                  </span>
                </div>
              </div>
            </div>
          </button>`
                )
            }
        },
    });

    if (slider.el) {
        const bullets = slider.el.querySelectorAll(".swiper-pagination-bullet");

        if (bullets) {
            bullets.forEach(bullet => {
                bullet.addEventListener("mouseover", () => {
                    bullet.click();
                })
            });
        }
    }
}

// TODO: Refactor direly needed
const initImagemapPins = () => {
    const pins = document.querySelectorAll(".ImagemapPin");
    const tooltips = document.querySelectorAll(".ImagemapTooltip");
    const slider = document.querySelector(".ImagemapSlider");

    if (pins.length > 0) {
        pins.forEach(pin => {
            let interval;
            let displayTimeout;
            let x;
            let y;

            const clearTracking = e => {
                if (window.innerWidth > 992) {
                    document.removeEventListener("mousemove", trackMouse);
                    clearTimeout(displayTimeout);
                    clearInterval(interval);
                    tooltip.style.visibility = "hidden";
                }
            }

            const trackMouse = e => {
                x = e.clientX;
                y = e.clientY;
            }

            const tooltip = document.querySelector(`#${pin.dataset.tooltipId}`);

            pin.addEventListener("click", e => {
                if (window.innerWidth < 992) {
                    pins.forEach(pin => {
                        if (pin === e.currentTarget) {
                            pin.classList.add("-clicked");
                        } else {
                            pin.classList.remove("-clicked");
                        }
                    });
                    tooltips.forEach(tt => {
                        if (tt.id === e.currentTarget.dataset.tooltipId) {
                            tt.style.visibility = "visible";
                        } else {
                            tt.style.visibility = "hidden";
                        }
                    });
                }
            });

            pin.addEventListener("mouseenter", () => {
                if (window.innerWidth > 992) {
                    document.addEventListener("mousemove", trackMouse);
                    interval = setInterval(() => {
                        tooltip.style.left = `calc(${x}px - 2rem)`;
                        tooltip.style.top = `calc(${y}px + 2rem)`;
                    }, 16);
                    displayTimeout = setTimeout(() => tooltip.style.visibility = "visible", 17);
                }
            });

            pin.addEventListener("mouseleave", clearTracking);

            window.addEventListener("resize", () => {
                if (window.innerWidth < 992) {
                    try {
                        tooltip.setAttribute("style", "");
                    } catch (e) {
                        // BUG: Undefined when resizing
                    }
                    const activeSlide = slider.querySelector(".swiper-slide-active");
                    const defaultPin = activeSlide.querySelector(".ImagemapPin");
                    defaultPin.click();
                } else {
                    pins.forEach(pin => {
                        pin.classList.remove("-clicked");
                    });
                    tooltips.forEach(tt => {
                        try {
                            tt.setAttribute("style", "");
                        } catch (e) {
                            // BUG: Undefined when resizing
                        }
                    });
                }
            });
        });
    }
}

const initIngredientSidebars = () => {
    let section;
    let ingredients;

    section = document.querySelector(".IngredientSidebars");
    if (section) {
        ingredients = section.querySelectorAll(".IngredientSidebars__Ingredient");
    }

    if (section && ingredients.length > 0) {
        ingredients.forEach(ing => {
            const anim = gsap.fromTo(
                ing,
                {opacity: 0, scale: 0.5},
                {
                    scrollTrigger: {
                        trigger: section,
                        endTrigger: section,
                        start: `top 50%`,
                        end: `top top`,
                        toggleActions: "play play none none",
                    }, opacity: 1, scale: 1, duration: 0.5
                }
            );
        });
    }
}

const initJobCollapsers = () => {
    const joblists = document.querySelectorAll(".JobList");
    if (joblists.length > 0) {
        joblists.forEach(list => {
            const jobs = list.querySelectorAll(".Job");
            if (jobs.length > 0) {
                jobs.forEach(job => {
                    let otherJobs = [];
                    jobs.forEach(oJob => {
                        job !== oJob ? otherJobs.push(oJob) : false;
                    });
                    const moreBtn = job.querySelector(".Button.-gblack");
                    const collapser = job.querySelector(".Job__Collapser");

                    collapser.style.height = 0;

                    moreBtn.addEventListener("click", () => {
                        job.classList.add("-is-expanded");
                        collapser.style.height = `${collapser.scrollHeight}px`;
                        otherJobs.forEach(oJob => {
                            oJob.classList.remove("-is-expanded");
                            oJob.querySelector(".Job__Collapser").style.height = 0;
                        });
                    });
                });
            }
        });
    }
}

const initCareerModal = () => {
    let modalBackdrop;
    let modal;
    let openBtns;
    let fileInput;
    let fileDisplay;
    let closeBtn;
    let positionInput;

    modalBackdrop = document.querySelector(".ModalBackdrop");

    if (modalBackdrop) {
        modal = modalBackdrop.querySelector(".Modal");
    } else {
        return false;
    }

    openBtns = document.querySelectorAll(".Job .Button.-js-modal-career");

    fileInput = modal.querySelector("#modal-form-cv");

    fileDisplay = modal.querySelector(".Modal__FileName");

    positionInput = modal.querySelector("#CF_positionInput");

    closeBtn = modal.querySelector(".Modal__Close");

    modal.addEventListener("click", e => {
        e.stopPropagation();
    });

    if (openBtns.length > 0) {
        openBtns.forEach(btn => {
            btn.addEventListener("click", (e) => {
                openModal();
                // Fill position input value
                positionInput.value = e.target.getAttribute("data-position");
            });
        });
    } else {
        return false;
    }

    modalBackdrop.addEventListener("click", () => {
        closeModal()
    });

    fileInput.addEventListener("change", e => {
        handleFileChoice()
    });

    closeBtn.addEventListener("click", () => {
        closeModal()
    });

    const openModal = () => {
        document.body.style.overflow = "hidden";
        modalBackdrop.classList.add("-is-active");
    }

    const closeModal = () => {
        document.body.style.overflow = "visible";
        modalBackdrop.classList.remove("-is-active");
    }

    const handleFileChoice = () => {
        fileDisplay.textContent = fileInput.value.replace(/\\/g, "/").split("/").pop();
    }
}

const initMegamenuImages = () => {
    const megamenu = document.querySelector("#navbar-megamenu");
    const items = megamenu.querySelectorAll(".navbar__dropdown-link");
    const images = megamenu.querySelectorAll(".navbar__dropdown-image");

    const switchImg = e => {
        images.forEach(img => {
            if (e.target.dataset.imageId === img.id) {
                img.classList.add("-is-active");
            } else {
                img.classList.remove("-is-active");
            }
        })
    }

    items.forEach(itm => {
        itm.addEventListener("mouseenter", e => switchImg(e));
    });
}

const detectTabNavigation = e => {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', detectTabNavigation);
    }
}

// Navbar scripts
document.addEventListener("DOMContentLoaded", () => {
    const body = document.querySelector("body");
    const drawer = document.querySelector(".navbar__drawer");
    const backdrop = document.querySelector(".navbar-drawer-backdrop");
    const toggleButton = document.querySelector(".navbar__toggle");

    const toggleDrawer = () => {
        const expandedDropdownItems = drawer.querySelectorAll(".navbar__item--dropdown-expanded");
        expandedDropdownItems.forEach(item => {
            item.classList.remove("navbar__item--dropdown-expanded");
        });
        drawer.classList.toggle("navbar__drawer--expanded");
        backdrop.classList.toggle("navbar-drawer-backdrop--visible");
        toggleButton.classList.toggle("navbar__toggle--active");
        body.style.overflowY === "hidden" ? body.style.overflowY = "auto" : body.style.overflowY = "hidden";
    }

    const closeDrawer = () => {
        const expandedDropdownItems = drawer.querySelectorAll(".navbar__item--dropdown-expanded");
        expandedDropdownItems.forEach(item => {
            item.classList.remove("navbar__item--dropdown-expanded");
        });
        drawer.classList.remove("navbar__drawer--expanded");
        backdrop.classList.remove("navbar-drawer-backdrop--visible");
        toggleButton.classList.remove("navbar__toggle--active");
        body.style.overflowY = "auto"
    }

    const closeDrawerWhenBreakpointLg = () => {
        if (window.innerWidth >= 992) {
            closeDrawer();
        }
    }

    toggleButton.addEventListener("click", toggleDrawer);
    backdrop.addEventListener("click", closeDrawer);
    window.addEventListener("resize", closeDrawerWhenBreakpointLg);
});

document.addEventListener("DOMContentLoaded", () => {
    const drawer = document.querySelector(".navbar__drawer");
    const drawerItems = drawer.querySelectorAll(".navbar__item");

    const toggleDropdown = item => {
        if (window.innerWidth < 992) {
            item.classList.toggle("navbar__item--dropdown-expanded");
        }
    }

    drawerItems.forEach(item => {
        const dropdown = item.querySelector(".navbar__dropdown");
        if (dropdown) {
            const link = item.querySelector(".navbar__link");
            link.addEventListener("click", e => {
                toggleDropdown(item);
            });
        }
    });
});

const initSmoothScrollBecauseAppleSucks = () => {
    const ss = new SmoothScroll('a[href*="#"]', {
        offset: (anchor, toggle) => {
            if (window.innerWidth < 992) {
                return 64
            } else {
                return 86
            }
        }
    });
}

// Mail form scripts
document.addEventListener("DOMContentLoaded", () => {
    const formIds = ["#contact-form-default", "#contact-form-delivery", "#contact-form-modal"];
    formIds.forEach(formId => {
        const form = document.querySelector(formId);
        if (form) {
            // const nameInput = form.querySelector("#contact-form-name");
            const emailInput = form.querySelector('input[type="email"]');
            // const telInput = form.querySelector("#contact-form-tel");
            // const msgInput = form.querySelector("#contact-form-msg");
            // const gdprInput = form.querySelector("#contact-form-gdpr");
            // const submitButton = form.querySelector("#contact-form-submit");
            // const validityState = {
            //   name: false,
            //   email: false,
            //   tel: false,
            //   msg: false,
            //   gdpr: false
            // }

            // nameInput.addEventListener("input", () => {
            //   if (nameInput.value !== "") {
            //     changeValidityState("name", true);
            //     emailInput.classList.remove("-invalid");
            //   } else {
            //     changeValidityState("name", false);
            //     emailInput.classList.add("-invalid");
            //   }
            // });

            emailInput.addEventListener("input", () => {
                const re = /.+@.+\..+/;
                if (re.test(emailInput.value)) {
                    // changeValidityState("email", true);
                    emailInput.classList.remove("-invalid");
                } else {
                    // changeValidityState("email", false);
                    emailInput.classList.add("-invalid");
                }
            });

            // telInput.addEventListener("input", () => {
            //   if (telInput.value !== "") {
            //     changeValidityState("tel", true);
            //   } else {
            //     changeValidityState("tel", false);
            //   }
            // });
            //
            // msgInput.addEventListener("input", () => {
            //   if (msgInput.value !== "") {
            //     changeValidityState("msg", true);
            //   } else {
            //     changeValidityState("msg", false);
            //   }
            // });
            //
            // gdprInput.addEventListener("input", () => {
            //   if (gdprInput.checked) {
            //     console.log("ce")
            //     changeValidityState("gdpr", true);
            //   } else {
            //     console.log("noce")
            //     changeValidityState("gdpr", false);
            //   }
            // });
            //
            // const changeValidityState = (prop, newVal) => {
            //   validityState[prop] = newVal;
            //   checkFormValidity();
            // }
            //
            // const checkFormValidity = () => {
            //   let valid = true;
            //   for (let prop in validityState) {
            //     if (validityState[prop] === false) {
            //       valid = false;
            //       break;
            //     }
            //   }
            //   if (valid) {
            //     changeFormState("enabled");
            //   } else {
            //     changeFormState("disabled");
            //   }
            // }
            //
            // const changeFormState = (state) => {
            //   if (state === "enabled") {
            //     submitButton.disabled = false
            //   } else {
            //     submitButton.disabled = true;
            //   }
            // }
            //
            // checkFormValidity();
        }
    });
})

// Polyfills
if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}


var classIsActive = 'is-active'

$(window).bind('load', function () {
    // Page Loader

    // setTimeout(function() {
        $('body').addClass(classIsActive)
        //your code to be executed after 1 second
    // }, 3000);
})